import Swiper from 'swiper';
import { add_swiper_class } from '@mycashbacklanding/js/tools/swiper';

export default class Slider {

	constructor()
	{
		Slider.hero();
		Slider.related_post();
	}

	/**
	 * Slider banner
	 */
	static hero()
	{
		let slider         = '[data-id="wpiris-hero-slider"]',
			slider_wrapper = '[data-id="wpiris-hero-slider-wrapper"]',
			slider_item    = '[data-id="wpiris-hero-slider-item"]';

		if ( $( slider ).length > 0 ) {

			add_swiper_class( $( slider ), $( slider_wrapper ), $( slider_item ) );

			new Swiper( $( slider ), {
				mousewheel: {
					forceToAxis: true,
				},
				autoplay: {},
				speed: 600,
				slidesPerView: 1,
				loop: true,
				lazy: true,
			} );
		}
	}

	/**
	 * Slider contenu relatif
	 */
	static related_post() {

		let slider = '[data-id="wpiris-related-post"]',
			slider_wrapper = '[data-id="wpiris-related-post-wrapper"]',
			slider_item = '[data-id="wpiris-related-post-item"]';

		if ($(slider).length > 0) {

			$(slider).each(function () {

				add_swiper_class( $(slider), $(slider_wrapper), $(slider_item) );

				let slides_per_view = undefined !== $(this).attr('data-slides-per-view') ? $(this).attr('data-slides-per-view') : 3,
					slides_per_view_large = undefined !== $(this).attr('data-slides-per-view-large') ? $(this).attr('data-slides-per-view-large') : 3,
					slides_per_view_medium = undefined !== $(this).attr('data-slides-per-view-medium') ? $(this).attr('data-slides-per-view-medium') : 2,
					slides_per_view_small = undefined !== $(this).attr('data-slides-per-view-small') ? $(this).attr('data-slides-per-view-small') : 2;

				new Swiper( $(this), {
					slidesPerView: slides_per_view_small,
					spaceBetween: 10,
					speed: 600,
					keyboard: true,
					freeMode: true,
					watchSlidesVisibility: true,
					passiveListeners: false,
					breakpoints: {
						650: {
							slidesPerView: slides_per_view_medium,
							spaceBetween: 20,
						},
						1000: {
							slidesPerView: slides_per_view_large,
							spaceBetween: 20,
						},
						1381: {
							slidesPerView: slides_per_view,
							spaceBetween: 40,
						}
					}
				});

			});
		}
	}
}